module.exports = __webpack_public_path__ + "9bf4ad6b72fe411e8d6f6ca53d2b7233.pdf";